const token = localStorage.getItem('token')
export const authInitialState = {
    loading: false,
    user: token ? {token} : null,
    error: null
}
